/** Geometry of drag-and-drop reordering in a vertical list (no DOM here, so it can be tested). */

/** The slot whose centre is nearest to y (page coordinates). Centres are measured once when the drag starts. */
export function nearestSlot(y: number, centers: number[]): number {
  let best = 0;
  for (let i = 1; i < centers.length; i++) if (Math.abs(y - centers[i]) < Math.abs(y - centers[best])) best = i;
  return best;
}

export const AUTO_SCROLL_ZONE = 80;
export const AUTO_SCROLL_MAX = 18;

/**
 * Pixels per frame to scroll while the finger is near the top or bottom edge of the viewport: negative upwards,
 * growing the closer the finger gets to the edge, 0 outside the zones.
 */
export function autoScrollSpeed(clientY: number, viewportHeight: number, zone = AUTO_SCROLL_ZONE, max = AUTO_SCROLL_MAX): number {
  if (clientY < zone) return -Math.round(max * Math.min(1, (zone - clientY) / zone));
  if (clientY > viewportHeight - zone) return Math.round(max * Math.min(1, (clientY - (viewportHeight - zone)) / zone));
  return 0;
}

/**
 * How far item k is moved out of the way while the item at `from` is dragged to slot `to`: the items in between
 * move by the dragged item's size (its height plus the gap), up when it goes down and down when it goes up. The
 * DOM order is kept during the drag (moving the dragged element would lose its pointer capture).
 */
export function shiftFor(k: number, from: number, to: number, size: number): number {
  if (from < to && k > from && k <= to) return -size;
  if (to < from && k >= to && k < from) return size;
  return 0;
}
